module.exports = __webpack_public_path__ + "img/building-2.7baab870.svg";